<template>
  <nav class="navbar bg-gray-900 border-b border-gray-700">
    <div class="container mx-auto px-4">
      <div class="flex items-center justify-between h-16">
        <!-- Logo -->
        <router-link to="/" class="flex items-center space-x-2">
          <div class="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center">
            <span class="text-white font-bold">C</span>
          </div>
          <span class="text-xl font-bold text-white">CuttleFusion</span>
        </router-link>
        
        <!-- Navigation Links -->
        <div class="hidden md:flex items-center space-x-6">
          <router-link 
            to="/game" 
            class="nav-link text-gray-300 hover:text-white transition-colors"
          >
            Game
          </router-link>
          <router-link 
            to="/collection" 
            class="nav-link text-gray-300 hover:text-white transition-colors"
          >
            Collection
          </router-link>
          <router-link 
            to="/marketplace" 
            class="nav-link text-gray-300 hover:text-white transition-colors"
          >
            Marketplace
          </router-link>
          <router-link 
            to="/leaderboard" 
            class="nav-link text-gray-300 hover:text-white transition-colors"
          >
            Leaderboard
          </router-link>
        </div>
        
        <!-- Wallet Connection -->
        <div class="flex items-center space-x-4">
          <button
            v-if="!isConnected"
            @click="openWalletModal"
            class="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg transition-colors"
          >
            Connect Wallet
          </button>
          
          <div v-else class="flex items-center space-x-2">
            <div class="text-sm text-gray-300">
              {{ shortenAddress(walletAddress) }}
            </div>
            <button
              @click="disconnect"
              class="bg-gray-700 hover:bg-gray-600 text-white px-3 py-2 rounded-lg transition-colors"
            >
              Disconnect
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useWeb3Store } from '@/stores/web3'

const emit = defineEmits<{
  openWallet: []
}>()

const web3Store = useWeb3Store()

const isConnected = computed(() => web3Store.isConnected)
const walletAddress = computed(() => web3Store.address)

const openWalletModal = () => {
  emit('openWallet')
}

const disconnect = () => {
  web3Store.disconnect()
}

const shortenAddress = (address: string) => {
  if (!address) return ''
  return `${address.slice(0, 6)}...${address.slice(-4)}`
}
</script>

<style scoped>
.nav-link.router-link-active {
  color: #a855f7;
}

.nav-link:hover {
  color: #c084fc;
}
</style>